import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { LogoutUser, StoreState } from 'core/store';
import { SnackBarComponent } from '../../page/shared/components/snack-bar/snack-bar.component';
import { t, I18nKeys } from 'core/utils/i18n.util';
import {
    composeLocalizedMessage,
    composeLocalizedMessages,
    getErrorMessageDetails,
    getErrorMessages,
} from 'core/utils/localized-message.util';

export const WhiteList = [
    'NamesNotFound',
    'AppointmentNotExists',
    'AppointmentUserTasksIsEmpty',
    'ClientIsExists',
];

/** Handled by feature dialogs (e.g. periodicity confirm); skip global snackbar. */
const DialogHandledErrorCodes = ['PeriodicityWarning'];

@Injectable()
export class ErrorHandler {
    constructor(
        public snackbar: MatSnackBar,
        public translate: TranslateService,
        public store: Store<StoreState>,
    ) {}

    handleError(err: any) {
        if (err.status === 401) {
            this.store.dispatch(new LogoutUser());
        } else {
            try {
                if (err.error instanceof Blob) {
                    err.error.text().then(value => {
                        if (value) {
                            const isReport = err.url.includes('Reports');
                            const message = JSON.parse(value);
                            if (message && !isReport) {
                                if (message.ErrorText) {
                                    this.snackbar.open(message.ErrorText[0], t(I18nKeys.ACTIONS_OK), {
                                        duration: 300000,
                                    });
                                } else if (message?.error?.message) {
                                    this.snackbar.open(message?.error?.message, t(I18nKeys.ACTIONS_OK), {
                                        duration: 300000,
                                    });
                                }
                            }
                        }
                    });
                } else if (err.error?.ErrorCode && err.error?.ErrorText?.length) {
                    const code = Array.isArray(err.error?.ErrorCode)
                        ? err.error?.ErrorCode[0]
                        : err.error?.ErrorCode;
                    const errorText = err.error?.ErrorText?.[0] as string | undefined;
                    const errorParams = err.error?.ErrorParams || err.error?.errorParams;

                    let interpolationParams: any | undefined = errorParams;

                    // Legacy: extract name from UA ErrorText when ErrorParams is absent
                    if (
                        !interpolationParams &&
                        (code === 'ServiceCannotBeDeleted' ||
                            code === 'ProjectCannotBeDeleted' ||
                            code === 'PackageCannotBeDeleted') &&
                        errorText
                    ) {
                        const nameMatch = errorText.match(/'([^']+)'/);
                        if (nameMatch && nameMatch[1]) {
                            interpolationParams = { name: nameMatch[1] };
                        }
                    }

                    if (code && !WhiteList.includes(code)) {
                        if (code !== 'ClientIsExists' && code !== 'HasProjectItemOrganizationDeliveryPoint') {
                            let message = composeLocalizedMessage(
                                this.translate,
                                code,
                                interpolationParams,
                                errorText || code,
                            );

                            if(code === 'NewContractIsDuplicate') {
                                message = t(I18nKeys.CONTRACTS_NEW_CONTRACT_IS_DUPLICATE);
                            };

                            if(code === 'LimitAppTaskCountForConsultant') {
                                message = t(I18nKeys.MEETINGS_LIMIT_APP_TASK_COUNT_FOR_CONSULTANT);
                            };

                            if(code === 'NotPossibleToRestoreService') {
                                message = t(I18nKeys.MEETINGS_NOT_POSSIBLE_TO_RESTORE_SERVICE);
                            };

                            if(code === 'LimitAppTaskCountForConsultantOrNotEnoughtForNumberClients') {
                                message = t(I18nKeys.MEETINGS_LIMIT_APP_TASK_COUNT_FOR_CONSULTANT_OR_NOT_ENOUGH_FOR_NUMBER_CLIENTS);
                            };

                            this.snackbar.open(message, t(I18nKeys.ACTIONS_OK), {
                                duration: 300000,
                            });
                        }
                    }
                } else if (
                    err.error?.ErrorCode &&
                    (getErrorMessageDetails(err.error) || getErrorMessages(err.error))
                ) {
                    const multiCode = Array.isArray(err.error?.ErrorCode)
                        ? err.error?.ErrorCode[0]
                        : err.error?.ErrorCode;
                    if (!DialogHandledErrorCodes.includes(multiCode)) {
                        const html = composeLocalizedMessages(
                            this.translate,
                            getErrorMessageDetails(err.error),
                            getErrorMessages(err.error),
                        );
                        this.snackbar.openFromComponent(SnackBarComponent, {
                            data: html,
                            duration: 300000,
                        });
                    }
                } else if (err.error?.error?.message) {
                    this.snackbar.open(err.error?.error?.message, t(I18nKeys.ACTIONS_OK), {
                        duration: 300000,
                    });
                } else if (err.error?.errorText) {
                    this.snackbar.open(err.error?.errorText[0], t(I18nKeys.ACTIONS_OK), {
                        duration: 300000,
                    });
                } else if (err.error?.ErrorText) {
                    this.snackbar.open(err.error?.ErrorText[0], t(I18nKeys.ACTIONS_OK), {
                        duration: 300000,
                    });
                }
                if (err.error?.Value) {
                    this.snackbar.open(err.error?.Value[0], t(I18nKeys.ACTIONS_OK), {
                        duration: 300000,
                    });
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //   return next.handle(req)
    //     .pipe(
    //       catchError(err => {
    //         if (err.status === 401) {
    //           this.store.dispatch(new LogoutUser());
    //         } else if (err.error?.Value) {
    //           this.snackbar.open(err.error?.Value[0], 'ОК', {
    //             duration: 5000
    //           });
    //         } else if (err.error?.ErrorCode) {
    //             if (err.error?.ErrorCode[0] && !WhiteList.includes(err.error?.ErrorCode[0])) {
    //               console.log('err.error?.ErrorCode[0]');
    //               this.snackbar.open(err.error?.ErrorText[0], 'ОК', {
    //                 duration: 5000
    //               });
    //             }
    //         } else {
    //           console.log('err.error?.ErrorText[0]');
    //           this.snackbar.open(err.error?.ErrorText[0], 'ОК', {
    //             duration: 5000
    //           });
    //         }
    //         return throwError(err);
    //       })
    //     );
    // }
}
